"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8547],{

/***/ 78547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26793);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57833);
/* harmony import */ var static_pages_foodProgram_useFoodProgramCta__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31006);
/* harmony import */ var system_components_Container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10758);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: radial-gradient(\n    69.82% 65.59% at 63.96% 44.52%,\n    #e2ec97 7.76%,\n    #e7f4c3 79.45%\n  );\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var BottomCTA = function(props) {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)("food_program").t;
    var ctaHref = (0,static_pages_foodProgram_useFoodProgramCta__WEBPACK_IMPORTED_MODULE_4__/* .useFoodProgramCta */ .b)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        as: "section"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
            py: 8,
            textAlign: "center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(system_components_Container__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Typography, {
                        component: "h2",
                        mb: 5,
                        fontSize: 24,
                        fontWeight: 600,
                        children: t("bottomCTA.title")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Button, {
                            component: "a",
                            target: "_blank",
                            href: ctaHref,
                            rounded: true,
                            children: t("cta")
                        })
                    })
                ]
            })
        })
    }));
};
var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__["default"])(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box)(_templateObject());
/* harmony default export */ __webpack_exports__["default"] = (BottomCTA);


/***/ })

}]);